import { useState } from "react";

export function DeleteIcon({ onClick }) {
  const [hovered, setHovered] = useState(false);

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onClick}
      style={{ cursor: "pointer" }}
      id="delete-icon"
    >
      <path
        d="M18.6382 5.06182C17.4466 3.87025 15.9624 3.01324 14.3346 2.57716C12.7068 2.14095 10.993 2.14095 9.36525 2.57716C7.73747 3.01324 6.25327 3.87025 5.06171 5.06182C3.87014 6.25338 3.01328 7.73758 2.57706 9.36536C2.14098 10.9931 2.14098 12.707 2.57706 14.3347C3.01328 15.9625 3.87014 17.4467 5.06171 18.6383C6.25341 19.8298 7.7376 20.6867 9.36525 21.1229C10.9929 21.559 12.7068 21.559 14.3346 21.1229C15.9624 20.6867 17.4466 19.8298 18.6382 18.6383C19.8297 17.4466 20.6867 15.9624 21.1228 14.3347C21.559 12.7071 21.559 10.9932 21.1228 9.36536C20.6867 7.73758 19.8297 6.25338 18.6382 5.06182ZM14.8321 7.78726L15.9126 8.86781C16.0897 9.04486 16.0898 9.33012 15.9126 9.50717L13.5698 11.85L15.9126 14.1928C16.0897 14.3698 16.0897 14.6551 15.9126 14.8322L14.8321 15.9127C14.655 16.0898 14.3698 16.0899 14.1927 15.9127L11.8499 13.5699L9.50712 15.9127C9.33007 16.0898 9.04481 16.0898 8.86776 15.9127L7.78721 14.8322C7.61016 14.6551 7.61003 14.3698 7.78721 14.1928L10.13 11.85L7.78721 9.50717C7.61016 9.33011 7.61016 9.04486 7.78721 8.86781L8.86776 7.78726C9.04482 7.6102 9.33007 7.61007 9.50712 7.78726L11.8499 10.1301L14.1927 7.78726C14.3698 7.6102 14.655 7.6102 14.8321 7.78726Z"
        fill={hovered ? "#ff0800ff" : "#DD4C1E"}
        style={{ transition: "all 0.3s ease-out" }}
      />
    </svg>
  );
}
